import { render } from "./menuTop.vue?vue&type=template&id=4f87d945"
import script from "./menuTop.vue?vue&type=script&lang=js"
export * from "./menuTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__